<mat-dialog-content>
  <img [src]="dialogData.imageUrl"
    class="w-100" />
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button
    (click)="onClose()">Close</button>
</mat-dialog-actions>